module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-1000-Classes-Inactive-8acf93c7200dbe6f887a3761adc715da.png";